<h2>{{ 'revenue.arc.arc-builder' | translate }}</h2>

<div class="form-group col-sm-12" style="padding-right: 0px">
  <div class="pull-right">
    <a [routerLink]="['/revenue/pricing-calculations', 0]" class="btn btn-default">
      <span class="pi pi-plus"></span>
      {{ 'common.new' | translate | titlecase }}
    </a>
  </div>
</div>
<div style="clear: both"></div>

<p-table [showGridlines]="true"
  #arcsGrid
  [rows]="searchParams.PageSize"
  styleClass="wl-responsive-prime-datatable"
  [value]="arcsResult.Result"
  [paginator]="true"
  (onLazyLoad)="lazyLoadArcFormulas($event)"
  [totalRecords]="arcsResult.TotalCount"
  [lazy]="true"
  [loading]="loading"
>
  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
    <SortAltIcon *ngIf="sortOrder === 0">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
    </SortAltIcon>
    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
    </SortAmountUpAltIcon>
    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
    </SortAmountDownIcon>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th [hidden]="true">{{ 'revenue.arc.arc-id' | translate | uppercase }}</th>
      <th pSortableColumn="Descr">
        {{ 'revenue.arc.descr' | translate | titlecase }}
        <p-sortIcon field="Descr"></p-sortIcon>
      </th>
      <th pSortableColumn="ItemNum">
        {{ 'revenue.arc.revenue-item' | translate | titlecase }}
        <p-sortIcon field="ItemNum"></p-sortIcon>
      </th>
      <th style="width: 120px"></th>
    </tr>
    <tr>
      <th>
        <input
          pInputText
          placeholder="{{ 'revenue.arc.filter-by-descr' | translate | ucfirst }}"
          class="p-column-filter w-100"
          [(ngModel)]="searchParams.Descr"
          (input)="filterChanged()"
        />
      </th>
      <th>
        <p-select
          [options]="revenueItems"
          optionValue="ItemNum"
          optionLabel="ItemName"
          placeholder="{{ 'revenue.arc.filter-by-revenue-item' | translate | ucfirst }}"
          styleClass="p-column-filter w-100"
          [(ngModel)]="searchParams.ItemNum"
          (onChange)="filterChanged()"
          showClear
          appendTo="body"
        ></p-select>
      </th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template let-arc pTemplate="body">
    <tr>
      <td [hidden]="true">{{ arc.ArcID }}</td>
      <td>
        <div class="text-truncate">
          <a class="cursor-pointer" (click)="editArc(arc)">{{ arc.Descr }}</a>
        </div>
      </td>
      <td>{{ getRevenueItemName(arc.ItemNum) }}</td>
      <td class="text-center">
        <div class="mct-flex mct-row mct-gap-5">
          <button
            type="button"
            [disabled]="isSearching || isBusy"
            class="btn btn-primary"
            (click)="editArc(arc)"
            [pTooltip]="'common.edit' | translate | titlecase"
            tooltipPosition="top"
          >
            <i class="pi pi-pencil"></i>
          </button>
          <button
            type="button"
            [disabled]="isSearching || isBusy"
            class="btn btn-danger"
            (click)="confirmDeleteArc(arc)"
            [pTooltip]="'common.delete' | translate | titlecase"
            tooltipPosition="top"
          >
            <i class="pi pi-trash"></i>
          </button>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="3" class="text-center">
        {{ 'revenue.arc.no-arc' | translate | titlecase }}
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  modal="true"
  #deleteArcConfirmationModal
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-s"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <div class="p-3 text-center">
    <i class="pi pi-exclamation-triangle mr-2" style="font-size: 2rem; color: var(--red-500)"></i>
    <p>{{ 'revenue.arc.arc-delete-confirmation-prompt' | translate }}</p>
  </div>

  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-10">
      <wl-busy [show]="deleting"></wl-busy>
      <button
        pButton
        type="button"
        class="btn btn-danger"
        (click)="deleteArcConfirmed()"
        [disabled]="deleting"
        icon="pi pi-trash"
        [label]="(deleting ? 'common.deleting' : 'common.delete') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="btn btn-secondary"
        (click)="this.showModal = false"
        [disabled]="deleting"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>
